import React, { Fragment } from 'react';
import './App.css';
import Skill from "./Skill";
import Navbar from "./Navbar";
import ProfilePhoto from "./ProfilePhoto"
import Education from './Education';
import CatPic from "./CatPic";
import Footer from "./Footer";
import Copyright from './Copyright';

function App() {
  return (
    <Fragment>
      <Navbar />
      <ProfilePhoto />

      <div className="mainPar2">
        <Education />
        <Skill />
        <CatPic />
      </div>

      <div className="footerPar">
        <Footer />
      </div>

        <Copyright />
    </Fragment>
  );
}

export default App;

